export enum RoleName {
  ADMIN = "admin",
  EDITOR = "editor",
  VIEWER = "viewer",
}
